import axios from 'axios';
import authHeader from './auth-header';

function getBaseUrl() {
    let base = process.env.VUE_APP_BASE_URL;
    if (!base) {
        return (typeof window !== 'undefined' && window.location && window.location.origin) ? window.location.origin + '/' : '/';
    }
    return base.endsWith('/') ? base : base + '/';
}

function getApiUrl() {
    let api = process.env.VUE_APP_API_URL;
    if (!api) {
        return (typeof window !== 'undefined' && window.location && window.location.origin) ? window.location.origin + '/api/' : '/api/';
    }
    return api.endsWith('/') ? api : api + '/';
}

const BASE_URL = getBaseUrl();
const API_URL = getApiUrl();

class CommonServices {
    base_url(append){
        return API_URL+append
    }
    asset_url(append){
        return BASE_URL+append
    }
    local_asset_url(append){
        let prefix = (typeof window !== 'undefined' && window.location && window.location.origin) ? window.location.origin + '/' : '/';
        return prefix + append.replace(/^\/+/, '');
    }
    extend_url(append=''){return API_URL+append}

    upload_file(formData){
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.post(API_URL+ 'kspgAPI/CommonData/upload',formData,
            {headers: {
                'Content-Type': 'multipart/form-data',
                'X-API-KEY' : user ? user.token : ''
            }
        });
    }
    post_upload_file(url,formData){
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.post(API_URL+ url,formData,
            {headers: {
                'Content-Type': 'multipart/form-data',
                'X-API-KEY' : user ? user.token : ''
            }
        });
    }  
    post(url,formData){
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.post(API_URL+ url,formData,
            {headers: {
                'X-API-KEY' : user ? user.token : ''
            }
        });
    }
    put(url,formData){
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.put(API_URL+ url,formData,
            {headers: {
                'X-API-KEY' : user ? user.token : ''
            }
        });
    }
    delete(url,formData){
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.delete(API_URL+ url,
            { data:formData,
                headers: {
                'X-API-KEY' : user ? user.token : ''
            }
        });
    }
    get(url,params) {
        return axios.get(API_URL+url, {
            headers: authHeader(),
            params: params
        });
    }
}
export default new CommonServices();